/**
 * @generated SignedSource<<9c6a94a982bb27a52d952178ec03a480>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicCheckSuperTopic$data = {
  readonly types: ReadonlyArray<string | null> | null;
  readonly " $fragmentType": "topicCheckSuperTopic";
};
export type topicCheckSuperTopic$key = {
  readonly " $data"?: topicCheckSuperTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCheckSuperTopic">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "topicCheckSuperTopic"
};

(node as any).hash = "f7f7bbcc084b0870895bcae7f65cfcdc";

export default node;
